import {
	createContext,
	useContext,
	useState,
	useEffect,
	ReactNode,
} from 'react';
import { getCookie } from '@quizzach/utils';

interface CookieConsentContextValue {
	hasConsent: boolean;
	isPending: boolean;
	setHasConsent: (value: boolean) => void;
}

const CookieConsentContext = createContext<
	CookieConsentContextValue | undefined
>(undefined);

interface CookieConsentProviderProps {
	children: ReactNode;
}

export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = ({
	children,
}) => {
	const [hasConsent, setHasConsentState] = useState<boolean>(() => {
		const consent = getCookie('cookies_consent');
		return consent === 'true';
	});
	const [isPending, setIsPending] = useState<boolean>(!hasConsent);

	useEffect(() => {
		const consent = getCookie('cookies_consent');
		const consentValue = consent === 'true';
		setHasConsentState(consentValue);
		setIsPending(!consentValue);
	}, []);

	const setHasConsent = (value: boolean) => {
		setHasConsentState(value);
		setIsPending(false);
	};

	const value: CookieConsentContextValue = {
		hasConsent,
		isPending,
		setHasConsent,
	};

	return (
		<CookieConsentContext.Provider value={value}>
			{children}
		</CookieConsentContext.Provider>
	);
};

export const useCookieConsent = () => {
	const context = useContext(CookieConsentContext);
	if (context === undefined) {
		throw new Error(
			'useCookieConsent must be used within a CookieConsentProvider'
		);
	}
	return context;
};
